import React, { Component } from 'react';
import Button from "components/CustomButtons/Button.js";
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import SnackbarContent from "components/Snackbar/SnackbarContent.js";
import Warning from "@material-ui/icons/Warning";
import { TextField, MenuItem } from "@material-ui/core";
import { populateUserDetails } from '../../../store/actions';
import { connect } from 'react-redux';
import history from '../../../../../src/history';
import Simplert from 'react-simplert';
import { dataController } from '../../../store/api/api.js';
import authService from 'components/api-authorization/AuthorizeService';
import {
    container,
    title,
    main,
    mainRaised,
    mrAuto,
    blackColor,
    infoColor,
    mlAuto,
    hexToRgb,
} from "../../../../assets/jss/material-kit-pro-react.js";
import { isEmpty } from "lodash";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Client from 'getaddress-api';
import PasswordChecklist from "react-password-checklist"

import LoadingData from '../../lottieLoading.js';

import JSFile from '../../../../../../ClientApp/package.json';

import { loadingPage } from '../../../store/actions';
import { withRouter } from "react-router-dom";
import $ from 'jquery';
import { compose } from "redux";


const useStyles = theme => ({
    main,
    mainRaised,
    mrAuto,
    mlAuto,
    container: {
        ...container,
        zIndex: 2,
    },
    title: {
        ...title,
        "&, & + h4": {
        },
    },
    textCenter: {
        textAlign: "center",
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block",
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0",
    },
    left: {
        float: "left!important",
        display: "block",
    },
    right: {
        margin: "0",
        float: "right!important",
        display: "block",
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative",
    },
    subHeader: {
        ...title,
        "&, & + h2": {
        },
        padding: "20px 0 10px 0", textAlign: "justify"
    },
    content: {
        paddingBottom: "30px",
        paddingTop: "20px",
    },
    checked: {
        color: infoColor[0] + "!important",
    },
    checkedIcon: {
        width: "25px",
        height: "25px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", 0.54)",
        borderRadius: "3px",
    },
    uncheckedIcon: {
        width: "25px",
        height: "25px",
        padding: "9px",
        border: "0.5px solid rgba(" + hexToRgb(blackColor) + ", .54)",
        borderRadius: "3px",
    },
    closebuttonPopUp: {
        backgroundColor: "#21B6A8", border: "none", color: "white", padding: "15px 28px", textAlign: "center",
        textDecoration: "none", display: "inline-block", margin: "4px 2px", cursor: "pointer"
    },
    checkRoot: {
        padding: "14px",
        "&:hover": {
            backgroundColor:
                "rgba(" + hexToRgb(infoColor[0]) + ", 0.14) !important",
        },
    }
});




const errorMess = (msg) => toast.error(msg, {
    position: "bottom-right",
    autoClose: 9000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});


const notifyErrorMessage = () => toast.error('Please fill in the required fields before proceeding!', {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});


const invalidPCMessage = () => toast.error('Invalid UK Postcode', {
    position: "bottom-right",
    autoClose: 7000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored'
});



class UpdateUserInput extends Component {


    state = {

        email: '',
        password: '',
        confirmPassword: '',
        telephone: '',
        addressline1: '',
        addressline2: '',
        addressline3: '',
        addressline4: '',
        town: '',
        postcode: '',
        city: '',
        county: '',
        country: '',
        passwordMacth: false,
        creditLimit: 0,
        accountBalance: 0,


        addressList: [],
        apiAddressList: [],
        selectedAddress: [],


        active: false,

        didUserSave: false,

        //pop up message
        showAlert: false,
        typeAlert: '',
        titleAlert: '',
        messageAlert: '',


        //error message helpers
        telephonerror: false,
        addressline1error: false,
        postcodeError: false,
        cityError: false,
        townError: false,
        multipleErrors: false,



    }


    componentDidMount = async () => {
        //if (!isEmpty(this.props.user)) {

        //    const mapAddress = this.props.user.aspNetUserAddress;

        //    this.setState({
        //        email: this.props.user.email,
        //        telephone: this.props.user.telephone,
        //        selectedAddress: this.props.user.aspNetUserAddress
        //    }, () => {
        //    });

        //    // output addreess
        //    this.setState({
        //        addressline1: mapAddress.address1,
        //        addressline2: mapAddress.address2,
        //        addressline3: mapAddress.address3,
        //        addressline4: mapAddress.address4,
        //        county: mapAddress.county,
        //        country: mapAddress.country,
        //        town: mapAddress.town,
        //        city: mapAddress.city,
        //        postcode: mapAddress.postcode
        //    }, () => {
        //    });
        //}

        //else {
        //    console.log("not found", this.props.user);
        //    this.populatePage();
        //}

        this.populatePage();
    }


    populatePage = async () => {

        await this.props.populateUserDetails();
        if (this.props.user !== null) {
            this.setState({
                email: this.props.user.email,
                telephone: this.props.user.telephone,
                selectedAddress: this.props.user.aspNetUserAddress,
                accountBalance: this.props.user.accountbalance,
                creditLimit: this.props.user.creditlimit
            }, () => {
            });

            // output addreess
            this.setState({
                addressline1: this.state.selectedAddress.address1,
                addressline2: this.state.selectedAddress.address2,
                addressline3: this.state.selectedAddress.address3,
                addressline4: this.state.selectedAddress.address4,
                county: this.state.selectedAddress.county,
                country: this.state.selectedAddress.country,
                town: this.state.selectedAddress.town,
                city: this.state.selectedAddress.city,
                postcode: this.state.selectedAddress.postcode
            }, () => {
            });
        }
        else {
            alert("empty");
            // throw user to log in page
            /* history.push('/Login');*/
            this.props.history.push('/Login');
        }
    }




    displayMessage = (type, title, message) => {
        this.setState({
            showAlert: true,
            typeAlert: type,
            titleAlert: title,
            messageAlert: message
        }, () => {
            window.scrollTo(0, 0);
        });
    }


    handlePopUpMessage = () => {
        this.setState({ showAlert: false });

        if (this.state.didUserSave == true) {
            /*      history.push('/landing-pagePortal');*/
            this.props.history.push('/landing-pagePortal');
        }
    }


    handleEmailChange = (e) => {
        this.setState({ email: e.target.value }, () => {
        });
    }


    handlePhoneChange = e => {
        const x = /^(\d*\.)?\d+$/;
        if (e.target.value === '' || x.test(e.target.value)) {
            this.setState({ telephone: e.target.value, telephonerror: false }, () => {
            });
        };
    };

    handleAddressChange = (e) => {
        this.setState({ addressline1: e.target.value, addressline1error: false }, () => {
        });
    }

    handleCityChange = (e) => {
        this.setState({ city: e.target.value, cityError: false }, () => {
        });
    }


    handlePasswordChange = (e) => {
        this.setState({ password: e.target.value }, () => {
        });
    }

    handleconfirmPasswordChange = (e) => {
        this.setState({ confirmPassword: e.target.value }, () => {
        });
    }


    updatePasswordValResult = (value) => {
        if (this.state.passwordMacth !== value) {
            this.setState({ passwordMacth: value }, () => {
            });
        }
    }


    handleAddress1Line = (e) => {

        this.setState({
            addressline1: e.target.value, addressline1error: false,
        }, () => {
        });
    }

    handleAddress2Line = (e) => {

        this.setState({
            addressline2: e.target.value
        }, () => {
        });
    }

    handleAddress3Line = (e) => {

        this.setState({
            addressline3: e.target.value
        }, () => {
        });
    }

    handleAddress4Line = (e) => {

        this.setState({
            addressline4: e.target.value
        }, () => {
        });
    }



    handleTownChange = (e) => {
        this.setState({ town: e.target.value, townError: false }, () => {
        });
    }

    handleCountyChange = (e) => {
        this.setState({ county: e.target.value }, () => {
        });
    }

    handlePostcodeChange = (e) => {


        this.setState({
            postcode: e.target.value, postcodeError: false,

            selectedAddress: [],
            apiAddressList: [],
            addressList: [],
            //city: '',
            //addressline1: '',
            //addressline2: '',
            //addressline3: '',
            //addressline4: '',
            //county: '',
            //country: '',
            //town: ''
        }, () => {
        });


    }

    updateErrorList = async (value) => {
        this.setState({
            multipleErrors: value
        }, () => { });
    }



    validate = async () => {
        try {
            await this.updateErrorList(false); // set to false before it checks

            const { confirmPassword, password, email, postcode, addressline1, town, city } = this.state;

            if (isEmpty(postcode)) {
                this.setState({ postcodeError: true }, () => { });
                await this.updateErrorList(true);
            }

            //if (isEmpty(selectedAddress)) {
            //    errorMess('Please use the find address feature to select an address from the list!');
            //    window.scrollTo(0, 0);
            //    return false;
            //}

            if (isEmpty(addressline1)) {
                this.setState({ addressline1error: true }, () => { });
                await this.updateErrorList(true);
            }

            if (isEmpty(town)) {
                this.setState({ townError: true }, () => { });
                await this.updateErrorList(true);
            }

            if (isEmpty(city)) {
                this.setState({ cityError: true }, () => { });
                await this.updateErrorList(true);
            }

            // if passwords has data, user must want to change it
            if (!isEmpty(password) || (!isEmpty(confirmPassword))) {

                if (this.state.passwordMacth !== true) {
                    errorMess('Please Check the minimum password length, password complexity and password match requirements.');
                    return false;
                }
            }

            // checks to see if any errors were triggered above
            if (this.state.multipleErrors === true) {
                notifyErrorMessage();
                window.scrollTo(0, 0);
                return false;

            }
            else {
                return true; // no errors found
            }


        }
        catch (e) {

        }
    }


    isValidPostcode(p) {
        var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
        return postcodeRegEx.test(p);
    }


    async findAddresses() {
        try {

            const { postcode } = this.state;

            if (this.isValidPostcode(postcode)) {
                var postcodeRegEx = /(^[A-Z]{1,2}[0-9]{1,2})([0-9][A-Z]{2}$)/i;

                var formatPC = postcode.replace(postcodeRegEx, "$1 $2"); // fix postcode format to sui the API

                const key = JSFile.pcKey;

                const api = new Client(key);  // api key
                const findResult = await api.find(formatPC);


                if (findResult.isSuccess) {
                    const success = findResult.toSuccess();

                    this.setState({
                        addressList: success.addresses
                    }, () => {
                    });

                    this.PopulateAPIAddresses();
                }
                else {
                    const failed = findResult.toFailed();
                }

            }
            else {

                // not a valid UK post
                // Display message
                this.setState({ postcodeError: true }, () => { });
                invalidPCMessage();
            }
        } catch (e) {

        }

    }




    //async isEmailTakenCall(email) {
    //    try {

    //        const response = await fetch(authController + 'checkexistingemail/' + email, {
    //            method: 'post',
    //            headers: {
    //                'Content-Type': 'application/json',
    //            },

    //        })
    //            .then((response) => {
    //                if (response.status === 401) {
    //                    throw new Error("Unauthorised request");
    //                }
    //                return response;
    //            })
    //            .then(res => res.json())
    //            .catch();

    //        return response;
    //    }
    //    catch (e) {
    //    }
    //}


    async hanldeRegister() {
        try {

            if (await this.validate() === true) {

                await this.props.loadingPage(true);

                const token = await authService.getAccessToken();
                const response = await fetch(dataController + 'updateUserAccount/', {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        EmailAddress: this.state.email,
                        Telephone: this.state.telephone,
                        Active: true,
                        PasswordConfirmed: this.state.confirmPassword,
                        Address1: this.state.addressline1,
                        Address2: this.state.addressline2,
                        Address3: this.state.addressline3,
                        Address4: this.state.addressline4,
                        Postcode: this.state.postcode,
                        City: this.state.city,
                        Town: this.state.town,
                        County: this.state.county,
                        Country: this.state.country
                    })
                })

                    .then(res => res.json())
                    .catch();

                let data = await response;

                if (data.isSuccess === true) {
                    await this.props.loadingPage(false);
                    this.setState({ didUserSave: true }, () => { });
                    this.displayMessage("success", "Account Updated!!", data.message);

                }
                else {
                    await this.props.loadingPage(false);
                    this.displayMessage("error", "Oops, an Error has Occurred", data?.message);
                    return;
                }


            }
        }

        catch (e) {
        }
    }





    PopulateAPIAddresses() {
        try {
            const formatAdd = this.state.addressList.addresses?.map((row, i) => {
                var filtered = row.formatted_address.filter(Boolean);
                var splitRows = filtered.join(', ');
                return (
                    <MenuItem key={i} value={row} style={{ padding: '8px', paddingRight: '30px', paddingLeft: '15px', display: "flex" }}>
                        {splitRows}
                    </MenuItem>
                )
            });
            this.setState({ apiAddressList: formatAdd }, () => { });
        }
        catch (e) {
        }
    };




    onAutoPopulateAddrChange = (event) => {
        try {

            var selectedAddr = event.target.value;

            if (!isEmpty(selectedAddr)) {

                // Auto Populate fields 
                this.setState({
                    city: selectedAddr.town_or_city, cityError: false,
                    addressline1: selectedAddr.line_1, addressline1error: false,
                    addressline2: selectedAddr.line_2,
                    addressline3: selectedAddr.line_3,
                    addressline4: selectedAddr.line_4,
                    county: selectedAddr.county == "County Londonderry" ? "County Derry/Londonderry" : selectedAddr.county,
                    town: isEmpty(selectedAddr.locality) ? selectedAddr.town_or_city : selectedAddr.locality, // city and town can be the same 
                    country: selectedAddr.country,
                    selectedAddress: selectedAddr
                }, () => {
                });

            }
        } catch (e) {

        }
    };


    render() {
        const { classes } = this.props;
        let { showAlert, typeAlert, titleAlert, messageAlert, apiAddressList } = this.state

        if (this.props.loading === false) {
            return (
                <div className={classes.content}>
                    <div style={{ width: "100%" }}>
                        <div style={{ padding: "10x" }}>
                            <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                <i className="far fa-user-circle"></i> {' '}
                                Account Details</h3>
                            <Simplert
                                style={{
                                    width: '250px;',
                                    overflow: 'auto',
                                    fontWeight: "600px"
                                }}
                                showSimplert={showAlert}
                                type={typeAlert}
                                title={titleAlert}
                                message={messageAlert}
                                onClose={() => this.handlePopUpMessage()}
                                disableOverlayClick={true}
                                customCloseBtnClass={classes.closebuttonPopUp}
                            />
                            <GridContainer>





                                <GridItem xs={12} sm={6} md={6}>
                                    <TextField

                                        id="email"
                                        label="Email"
                                        fullWidth
                                        type="email"
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                            readOnly: true
                                        }}
                                        value={this.props.user === null ? '' : this.state.email ? this.state.email : ''}

                                    />


                                </GridItem>

                                <GridItem xs={12} sm={6} md={6}>
                                    <TextField
                                        id="telephone"
                                        label="Telephone"
                                        fullWidth
                                        margin="normal"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        value={this.state.telephone === null ? "" : this.state.telephone ? this.state.telephone : ''}
                                        pattern="/\B(?=(\d{3})+(?!\d))/g"
                                        type="number"
                                        onChange={this.handlePhoneChange}
                                        error={this.state.telephonerror}
                                        helperText={this.state.telephonerror ? "Please enter a valid telephone!" : null}
                                    />
                                </GridItem>
                            </GridContainer>

                            <GridContainer>

                                <GridItem xs={6} sm={3} md={3} style={{ padding: '16px' }}>
                                    <TextField variant="outlined" label="Account Balance" InputLabelProps={{
                                        shrink: true,
                                        readOnly: true
                                    }}
                                        value={this.props.user === null ? '' : this.state.accountBalance ? '£' + this.state.accountBalance.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '£0'} />
                                </GridItem>

                                <GridItem xs={6} sm={3} md={3} style={{ padding: '16px' }}>
                                    <TextField variant="outlined" label="Credit Limit" InputLabelProps={{
                                        shrink: true,
                                        readOnly: true
                                    }}
                                        value={this.props.user === null ? '' : this.state.creditLimit ? '£' + this.state.creditLimit.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : '£0'} />
                                </GridItem>
                            </GridContainer>




                            <div>
                                <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                    <i className="far fa-map"></i> {' '}
                                    Address Details</h3>
                                <GridContainer>


                                    {!isEmpty(this.state.apiAddressList) ?
                                        <GridItem xs={12} sm={12} md={12}>
                                            <TextField
                                                fullWidth
                                                id="apiAdd"
                                                label="Address List"
                                                helperText="Please select your address"
                                                margin="normal"
                                                variant="outlined"
                                                select
                                                focused
                                                onChange={this.onAutoPopulateAddrChange}
                                            >
                                                {apiAddressList}
                                            </TextField>


                                        </GridItem>
                                        : null}


                                    <GridItem xs={6} sm={3} md={3}>
                                        <TextField
                                            style={{ display: "flex" }}
                                            id="postcode"
                                            label="Postcode"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            type="text"
                                            value={this.state.postcode === null ? "" : this.state.postcode ? this.state.postcode : ''}
                                            onChange={this.handlePostcodeChange}
                                            error={this.state.postcodeError}
                                            helperText={this.state.postcodeError ? "Please enter a valid UK postcode!" : null}
                                            focused

                                        />

                                    </GridItem>

                                    <GridItem xs={6} sm={3} md={3} style={{ padding: '16px' }}>
                                        <Button
                                            style={{
                                                borderRadius: 2,
                                                padding: "14px 16px",
                                                fontSize: "12px"
                                            }}

                                            color="instagram"
                                            size="lg"
                                            target="_blank"
                                            onClick={() => this.findAddresses()}
                                        >
                                            <i className="fas fa-location-arrow"></i>
                                            &nbsp;  Find Address
                                        </Button>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>

                                        <TextField
                                            id="address1"
                                            label="Address Line 1"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true

                                            }}
                                            type="text"
                                            error={this.state.addressline1error}
                                            helperText={this.state.addressline1error ? "Please enter address line 1!" : null}
                                            onChange={this.handleAddress1Line}
                                            value={this.state.addressline1 === null ? "" : this.state.addressline1 ? this.state.addressline1 : ''}
                                        />
                                    </GridItem>




                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address2"
                                            label="Address Line 2"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true

                                            }}
                                            type="text"
                                            onChange={this.handleAddress2Line}
                                            value={this.state.addressline2 === null ? "" : this.state.addressline2 ? this.state.addressline2 : ''}
                                        />
                                    </GridItem>



                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address3"
                                            label="Address Line 3"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true

                                            }}
                                            type="text"
                                            onChange={this.handleAddress3Line}
                                            value={this.state.addressline3 === null ? "" : this.state.addressline3 ? this.state.addressline3 : ''}
                                        />


                                    </GridItem>


                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="address4"
                                            label="Address Line 4"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true

                                            }}
                                            type="text"
                                            onChange={this.handleAddress4Line}
                                            value={this.state.addressline4 === null ? "" : this.state.addressline4 ? this.state.addressline4 : ''}
                                        />


                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="town"
                                            label="Town"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            error={this.state.townError}
                                            helperText={this.state.townError ? "Please enter a town!" : null}
                                            type="text"
                                            onChange={this.handleTownChange}
                                            value={this.state.town === null ? "" : this.state.town ? this.state.town : ''}
                                        />


                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="city"
                                            label="City"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            error={this.state.cityError}
                                            helperText={this.state.cityError ? "Please enter a city" : null}
                                            type="text"
                                            onChange={this.handleCityChange}
                                            value={this.state.city === null ? "" : this.state.city ? this.state.city : ''}
                                        />


                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="county"
                                            label="County"
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true

                                            }}
                                            type="text"
                                            onChange={this.handleCountyChange}
                                            value={this.state.county === null ? "" : this.state.county ? this.state.county : ''}
                                        />


                                    </GridItem>

                                </GridContainer>
                            </div>


                            <div>
                                <h3 className={classes.title} style={{ borderBottom: "2px dashed grey", padding: "5px" }}>
                                    <i className="fas fa-unlock-alt"></i>
                                    {' '}
                                    Password </h3>
                                <SnackbarContent
                                    message={
                                        <span>
                                            <b>Password Alert:</b> Only enter a <b> password </b> if you wish to update the current password!
                                        </span>
                                    }
                                    close
                                    color="danger"
                                    icon={Warning}

                                />

                                <GridContainer>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <PasswordChecklist
                                            rules={["minLength", "specialChar", "number", "capital", "match", "lowercase"]}
                                            minLength={6}
                                            value={this.state.password}
                                            valueAgain={this.state.confirmPassword}
                                            onChange={(isValid) => { this.updatePasswordValResult(isValid) }}
                                            style={{ color: "#151617" }}
                                        />
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="password"
                                            label="Password"
                                            type="password"
                                            autoComplete="current-password"
                                            placeholder="Password...."
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value={this.state.password === null ? "" : this.state.password ? this.state.password : ''}
                                            onChange={this.handlePasswordChange}
                                        />

                                    </GridItem>

                                    <GridItem xs={12} sm={6} md={6}>
                                        <TextField
                                            id="passwordConfirm"
                                            label="Confirm Password"
                                            type="password"
                                            autoComplete="current-password"
                                            placeholder="Password...."
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            value={this.state.confirmPassword === null ? "" : this.state.confirmPassword ? this.state.confirmPassword : ''}
                                            onChange={this.handleconfirmPasswordChange}
                                        />
                                    </GridItem>





                                    <GridItem xs={12} sm={12} md={12} style={{ paddingTop: "40px" }}>
                                        <div className={classes.left}>
                                            <Button
                                                style={{
                                                    borderRadius: 2,
                                                    padding: "16px 20px",
                                                    fontSize: "15px"
                                                }}
                                                color="danger"
                                                size="lg"
                                                target="_blank"
                                                onClick={() => history.goBack()}
                                            >
                                                <i className="far fa-window-close"></i>
                                                &nbsp; Cancel
                                            </Button>


                                        </div>

                                        <div className={classes.right}>

                                            <Button
                                                style={{

                                                    borderRadius: 2,
                                                    padding: "16px 20px",
                                                    fontSize: "15px"
                                                }}

                                                color="success"
                                                size="lg"
                                                target="_blank"
                                                onClick={() => this.hanldeRegister()}
                                            >
                                                <i className="fas fa-check"></i>
                                                &nbsp;  update
                                            </Button>




                                        </div>
                                    </GridItem>
                                </GridContainer>


                                <div>
                                    <ToastContainer
                                        position="bottom-right"
                                        autoClose={5000}
                                        hideProgressBar={false}
                                        newestOnTop={false}
                                        closeOnClick
                                        rtl={false}
                                        pauseOnFocusLoss
                                        draggable
                                        pauseOnHover
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );

        }
        else {
            return (<LoadingData text={"Updating Data, Please Wait...."} />)
        }
    }
}


const mapStateToProps = state => {
    return {
        user: state.userReducer.user,
        username: state.userReducer.savedUserName,
        loading: state.userReducer.loadingPage
    };
};

export default compose(withRouter,connect(mapStateToProps, { loadingPage, populateUserDetails }))(withStyles(useStyles)(UpdateUserInput));

